import { IBaseComponentProps, NSListProduct, NSSpace, NSSpaceSizeType, NSLoading, NSRouterMakerProps, ProductCacheService } from 'namirasoft-site-react';
import Styles from './NSAHomePage.module.css';
import { ProductFullRow } from 'namirasoft-api-product';
import { useEffect, useState } from 'react';

export interface NSAHomePageProps extends IBaseComponentProps, NSRouterMakerProps
{
    product_id: string;
    custom?: {
        scope?: string;
        headline?: string;
        logo?: string;
        description?: string;
    }
}

export interface NSAHomePageState
{
    product: ProductFullRow | null;
}

export function NSAHomePage(props: NSAHomePageProps)
{
    let cache = ProductCacheService.get(props.product_id, props.notifier.onError);
    let [state, setState] = useState<NSAHomePageState>({ product: null });

    useEffect(() =>
    {
        cache.get().then(product =>
        {
            setState({ product });
        })
    });

    if (!state.product)
        return <NSLoading />;

    let scope = props.custom?.scope ?? `${state.product.name} Console`;
    let headline = props.custom?.headline ?? state.product.headline ?? "";
    let logo = props.custom?.logo ?? state.product.logo ?? "";
    let description = props.custom?.description ?? state.product.description ?? "";

    return (
        <div className={Styles.nsa_home_container}>
            <img
                src={logo}
                alt={state.product.name}
                width={256}
                height={256}
            />
            <NSSpace size={NSSpaceSizeType.MICRO} />
            <h2>{headline}</h2>
            <NSSpace size={NSSpaceSizeType.MICRO} />
            <p>{description}</p>
            <NSSpace size={NSSpaceSizeType.SMALL} />
            <NSListProduct scope={scope} name="Home" />
        </div>
    );
}